import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import ConfigContext from '../config-provider/ConfigContext';
const Grid = function Grid(props) {
    const [size, setSize] = useState('xl');
    const gridRef = useRef(null);
    useEffect(() => {
        if (gridRef && gridRef.current && gridRef.current.offsetHeight <= 50) {
            setSize('xs');
        }
    }, []);
    const { prefixCls: customizePrefixCls, className, selected, onSelectChange = noop, cornerPlacement, ...others } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const selectedPrefixCls = `${prefixCls}-grid-selected`;
    const classString = classNames(`${prefixCls}-grid`, className, {
        [`${selectedPrefixCls} ${selectedPrefixCls}-${cornerPlacement} ${selectedPrefixCls}-${size}`]: selected,
    });
    return React.createElement("div", Object.assign({}, others, { className: classString, ref: gridRef, onClick: () => onSelectChange(!selected) }));
};
Grid.displayName = 'CardGrid';
Grid.defaultProps = {
    cornerPlacement: 'bottomRight',
};
export default Grid;
